import {createLogger, memoize} from '@servicenow/ui-internal';

const logger = createLogger({
	module: '@servicenow/ui-core'
});

// Prevent the same validation error message from being printed more than once
export default memoize(logger, {profileName: 'ui-core logger'});
